import Vue from 'vue'
import Router from 'vue-router'
import Splash from '@/components/Splash'
import Home from '@/components/Home'
import Category from '@/components/Category'
import Submit from '@/components/Submit'
import Confirm from '@/components/Confirm'
import comscore from './comscore'
import atInternet from './atInternet'
import pixel from './pixel'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'splash',
      component: Splash
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/categorie/:categoryId([0-9])',
      name: 'category',
      component: Category,
      props: route => ({
        categoryId: parseInt(route.params.categoryId),
        nomineeId: null
      })
    },
    {
      path: '/categorie/:categoryId([0-9])/:nomineeId(\\d+)/:nomineeSlug([a-z0-9-]+)',
      name: 'nominee',
      component: Category,
      props: route => ({
        categoryId: parseInt(route.params.categoryId),
        nomineeId: parseInt(route.params.nomineeId, 10)
      })
    },
    {
      path: '/inzenden',
      name: 'submit',
      component: Submit
    },
    {
      path: '/bevestigen/:uuid([a-z0-9-]{36})',
      name: 'confirm',
      component: Confirm,
      props: route => ({
        uuid: route.params.uuid
      })
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

const npotag = {
  lib: null,
  tag: null,
  page: null,
  queue: [] | null,

  load() {
    const script = document.createElement('script')
    script.src = 'https://npotag.npo-data.nl/prod/npo-tag.min.js'
    script.async = true
    script.onload = npotag.onLoaded
    document.head.appendChild(script)
  },

  onLoaded() {
    npotag.lib = window.npotag
    npotag.tag = npotag.lib.newTag(
      {
        brand: 'avotros',
        brand_id: 630226,
        platform: 'site',
        environment: process.env.NODE_ENV === 'production' ? 'prod' : 'dev'
      },
      [npotag.lib.newGovoltePlugin()]
    )

    const queue = npotag.queue
    if (queue) {
      npotag.queue = null
      queue.forEach((method, args) => {
        npotag[method](...args)
      })
    }
  },

  trackPage(page) {
    if (npotag.queue) {
      npotag.queue.push({ method: 'trackPage', args: [page] })
      return
    }

    npotag.page = npotag.lib.newPageTracker(npotag.tag, {
      page,
      page_chapter1: 'programmas',
      page_chapter2: 'radioring',
      page_chapter3: 'stemtool',
      platform: 'site',
      broadcaster: 'avrotros',
      program: 'radioring',
      content_context_id: 'POMS_S_AT_5941185'
    })
    npotag.page.pageView()
  }
}
npotag.load()

router.afterEach(to => {
  if (!window.canTrackAnalytics()) {
    return
  }

  try {
    atInternet(to)
    comscore(to)
    pixel(to)
    npotag.trackPage(to.fullPath)
  } catch (e) {
    console.warn(e)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js